document.addEventListener("DOMContentLoaded",function() {

  /* Funtion toggle burger menu
  **************************************************************/
  function toggleBurgerMenu() {
    let btn = document.querySelector('#burger');
    let menu = document.querySelector('#primary-menu');
    let body = document.querySelector('body');
    let scrollPosition = 0;
    let opacityMobile = document.querySelector('.header__opacity_mobile');

    btn.addEventListener('click', function() {
      btn.classList.toggle('opened');
      menu.classList.toggle('opened');

      if(menu.classList.contains('opened')) {
        scrollPosition = window.pageYOffset;
        body.style.overflow = 'hidden';
        body.style.top = `-${scrollPosition}px`;
        body.style.width = '100%';
        setTimeout(function(){
          opacityMobile.classList.add('active');
        }, 500);
      } else {
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);
        opacityMobile.classList.remove('active');
      }
    })
  }
  toggleBurgerMenu();

  /* Funtion toggle sidebar on desktop
  **************************************************************/
  function toggleSidebarBar() {
    let btn = document.querySelector('.top-toolbar__burger_sidebar #burger');
    let sidebar = document.querySelector('.widget-area');
    let header = document.querySelector('.header');
    let content = document.querySelector('.content-area');

    if(btn !== null) {
      btn.addEventListener('click', function() {
        btn.classList.toggle('opened');
        sidebar.classList.toggle('closed');
        header.classList.toggle('to-left');
        content.classList.toggle('to-left');
      })
    }
  }
  toggleSidebarBar();

})

window.addEventListener('scroll', function() {

  /* Funtion toggle header opacity
  **************************************************************/
  function addHeaderBackground() {
    let header = document.querySelector('.header');

    if (window.pageYOffset > header.offsetTop) {
      header.classList.add('active');
    } else {
      header.classList.remove('active');
    }
  }
  addHeaderBackground();
  
});



// WEBPACK FOOTER //
// ./scripts/modules/global.js